import { Badge } from "./ui/Badge";

/**
 * The AI-transparency badge (decided, not optional — see the grilling
 * session this feature came out of): a bot account name/avatar alone is
 * easy to miss, especially in a DM, so every post/message it authors
 * carries this too.
 */
export function BotBadge({ className = "" }: { className?: string }) {
  return (
    <Badge
      tone="primary"
      title="Skrevet af en AI-bot, ikke en person"
      className={`px-1.5 text-[10px] leading-none ${className}`}
    >
      AI
    </Badge>
  );
}
